/*!
 * Modal thanks
 */
/* global Foundation */

const wrap = '#thanksModal';
const title = '.modal__title';
const body = '.modal__descriptions';

/**
 * Set modal text
 * @param options
 */
let setMessage = (options) => {
    if (Object.prototype.hasOwnProperty.call(options, 'title')) {
        $(title, wrap).html(options.title);
    }

    if (Object.prototype.hasOwnProperty.call(options, 'body')) {
        $(body, wrap).html(options.body);
    }
};

/**
 * Show modal
 * @param options
 * @param modalId
 */
let showModalNotification = (options = {}, modalId) => {
    if (modalId) {
        $(`#${modalId}`).foundation('open');

        return;
    }

    setMessage(options);
    $(wrap).foundation('open');
    // $(wrapModalThanks).foundation('open');
};

export {showModalNotification};
